import { Component, ElementRef, Inject, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { attachmentsGetLatestResume, getAttachmentsResumes } from '@app/collections/attachments';
import { Store } from '@ngrx/store';
import { CandidateAdapter, Skill } from '@shared/models';
import { SkillsService } from '@shared/services/skills.service';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'mojo-candidate-pdf-preview',
  templateUrl: './candidate-pdf-preview.component.html',
  styleUrls: ['./candidate-pdf-preview.component.scss'],
})
export class CandidatePdfPreviewComponent implements OnInit {
  @ViewChild('pdf') pdfContainerElement: ElementRef;
  @Input() candidateObj: CandidateAdapter;
  hardSkills$: Observable<Array<Skill>>;
  softSkills$: Observable<Array<Skill>>;

  candidate: CandidateAdapter;
  pdfSrc: string;
  filename: string;
  isLoading = true;
  isPdfLoaded = false;
  isCorrectExtension = false;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { candidate: CandidateAdapter },
    private store: Store,
    private skillsService: SkillsService,
  ) {}

  ngOnInit(): void {
    this.candidate = this.candidateObj || this.data.candidate;
    this.isLoading = true;
    this.loadDetails();
    this.getHardSkills$(this.candidate.id);
    this.getSoftSkills$(this.candidate.id);
  }

  private loadDetails() {
    this.store.dispatch(
      attachmentsGetLatestResume({
        payload: {
          candidateId: this.candidate.id,
          onlyPdfFiles: true,
        },
      }),
    );
    this.store
      .select(getAttachmentsResumes, {
        candidateId: this.candidate.id,
      })
      .pipe(
        filter((attachments) => attachments?.length > 0),
        take(1),
      )
      .subscribe((resumes) => {
        this.isLoading = false;
        this.filename = resumes[0].name;
        this.pdfSrc = resumes[0].path;
        this.isCorrectExtension = this.filename.toLowerCase().endsWith('.pdf');
      });
  }

  public getHardSkills$(candidateId): Observable<Array<Skill>> {
    if (!this.hardSkills$) {
      this.hardSkills$ = this.skillsService.getCandidateHardSkills(candidateId);
    }
    return this.hardSkills$;
  }

  public getSoftSkills$(candidateId): Observable<Array<Skill>> {
    if (!this.softSkills$) {
      this.softSkills$ = this.skillsService.getCandidateSoftSkills(candidateId);
    }
    return this.softSkills$;
  }

  pdfLoaded() {
    if (!this.isLoading) {
      this.isPdfLoaded = true;
      if (this.pdfContainerElement?.nativeElement) {
        this.pdfContainerElement.nativeElement.scrollTop = 0;
      }
    }
  }
}
